<div
    [ngClass]="[isInputElemHidden? 'mb-3  custom--input custom--select custom--select__height-hide' : 'mb-3  custom--input custom--select default', errorMessage?'has-error':'']"
    [formGroup]="inputFormGroup"
    *ngIf="hasControl && inputFormGroup"
>
    <label class="control-label" *ngIf="labelText">
        <span
            >{{ labelText
            }}
            <span *ngIf="isRequired" class="help--text__danger">*</span>
            <span *ngIf="isInputElemHidden" (click)="setInputElemHidden()" class="help--text__icons">
                    <i class="far fa-pencil-alt"></i>
            </span>
            <span *ngIf="!isInputElemHidden && isTouched" (click)="setIsTouchedFalse()" class="help--text__icons">
                    <i class="far fa-save"></i>
            </span>
        </span
        >
    </label>
    <fieldset [id]="rxID + 'f'" [disabled]="isDisabled">
    <!-- use  to disble select dropdown -->
    <span *ngIf="bindLabel" class="custom--select__span">
        <span *ngIf="!isInputElemHidden">
            <ng-select
                #rxNgSelect
                [id]="rxID"
                [formControlName]="custContrlName"
                [items]="processedDropdownList"
                [bindLabel]="bindLabel"
                [bindValue]="bindValue"
                (change)="triggerChange($event)"
                (keydown)="onEnter($event)"
                (blur)="triggerOnBlur($event)"
                [ngClass]="isDisabled? 'rx--select light_gray rx-select-custom': (changeText ? 'rx--select noTexttransform rx-select-custom' : 'rx--select rx-select-custom')"
                [attr.tabindex]="tabIndex"
                [required]="isRequired"
                [title]="titleText || ''"
                [appAutofocus]="autoFocus"
                [autofocusDelay]="100"
                (blur)="validateAllFormFields(inputFormGroup, custContrlName)"
                (keydown.shift.tab)="onShiftTabbingEvent($event)"
                (focus)="focusOnInput()"
                (open)="getWidth()"
                (keydown.tab)="focusonTab($event)"
                [appendTo]="IsAppendTo ? 'body' : '' "
                [class.appended-dropdown]="IsAppendTo"
                [clearable]="false"
                [searchable]="true"
                [readonly]="isDisabled"
                [disabled]="isDisabled"
                [virtualScroll]="false"
                [selectOnTab]="true"
                [closeOnSelect]="true"
                [typeToSearchText]="''"
            >
                <ng-template ng-label-tmp let-item="item">
                    <span *ngIf="hasBindLabel2">
                        {{changeText ? item[bindLabel] : (item[bindLabel] | uppercase)}}
                        <span *ngIf="item[bindLabel2] ">-{{ (" " + item[bindLabel2]) | uppercase}}</span>
                        <span *ngIf="item[bindLabel2] === 0">-{{ " 0"}}</span>
                    </span>
                    <span *ngIf="!hasBindLabel2">{{changeText ? item[bindLabel] : (item[bindLabel] | uppercase)}}</span>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div class="rx-option-row" *ngIf="hasBindLabel2" [autoTooltip]="titleText">
                        <div class="rx-option-left">
                            <h6>{{ item[bindLabel] | uppercase}}</h6>
                        </div>
                        <div class="rx-option-right custom--select__dataflow">
                            <h6 *ngIf="item[bindLabel2] ">-{{ (" " + item[bindLabel2]) | uppercase}}</h6>
                            <h6 *ngIf="item[bindLabel2] === 0">-{{ " 0"}}</h6>
                        </div>
                    </div>
                    <div *ngIf="!hasBindLabel2" 
                        [autoTooltip]="item.disabled ? 'As it is Manual Rx ELECTRONIC option is disabled' : (changeText ? item[bindLabel] : (item[bindLabel] | uppercase))">
                        {{changeText ? item[bindLabel] : (item[bindLabel] | uppercase)}}
                    </div>
                </ng-template>
            </ng-select>
        </span>
        <span *ngIf="isInputElemHidden">
            <div class="label--data">
                <span *ngIf="inputFormGroup?.value[custContrlName]">
                    <span *ngFor="let list of dropdownList">
                        <span *ngIf="(bindValue ? list[bindValue] : list) == inputFormGroup?.value[custContrlName]"> {{list[bindLabel] }}
                            <span *ngIf="list[bindLabel2] ">-{{ (" " + list[bindLabel2]) | uppercase}}</span>
                            <span *ngIf="list[bindLabel2] === 0">-{{ " 0"}}</span>
                        </span>
                    </span>
                </span>
                <span *ngIf="!inputFormGroup?.value[custContrlName]">
                        --
                </span>
            </div>
        </span>
    </span>
    <span *ngIf="!bindLabel" class="custom--select__span">
        <span *ngIf="!isInputElemHidden">
            <ng-select
                #rxNgSelect
                [id]="rxID"
                [formControlName]="custContrlName"
                [items]="processedDropdownList"
                (change)="triggerChange($event)"
                (keydown)="onEnter($event)"
                (blur)="triggerOnBlur($event)"
                [ngClass]="isDisabled? 'rx--select light_gray rx-select-custom': 'rx--select rx-select-custom'"
                [attr.tabindex]="tabIndex"
                [required]="isRequired"
                [title]="titleText || ''"
                [appAutofocus]="autoFocus"
                [autofocusDelay]="100"
                (blur)="validateAllFormFields(inputFormGroup, custContrlName)"
                (keydown.shift.tab)="onShiftTabbingEvent($event)"
                (focus)="focusOnInput()"
                (keydown.tab)="focusonTab($event)"
                (open)="getWidth()"
                [appendTo]="IsAppendTo ? 'body' : '' "
                [class.appended-dropdown]="IsAppendTo"
                [clearable]="false"
                [searchable]="true"
                [readonly]="isDisabled"
                [disabled]="isDisabled"
                [virtualScroll]="false"
                [selectOnTab]="true"
                [closeOnSelect]="true"
                [typeToSearchText]="''"
            >
                <!-- <ng-option *ngFor="let list of dropdownList" [value]="list" [id]="list">
                    {{ list }}
                </ng-option> -->
            </ng-select>
        </span>
        <span *ngIf="isInputElemHidden">
            <div class="label--data">
                <span *ngIf="inputFormGroup?.value[custContrlName]">
                        {{inputFormGroup?.value[custContrlName]}}
                </span>
                <span *ngIf="!inputFormGroup?.value[custContrlName]">
                        --
                </span>
            </div>
        </span>
    </span>
</fieldset>
    <span class="help-block" *ngIf="errorMessage"> {{ errorMessage }} </span>
</div>

<div
    [ngClass]="[isInputElemHidden? 'mb-3  custom--input custom--select custom--select__height-hide' : 'mb-3  custom--input custom--select default',
        errorMessage?'has-error':'']"
    *ngIf="!hasControl"
>
    <label class="control-label" *ngIf="labelText">
        <span>{{ labelText }}</span>
    </label>
    <fieldset [id]="rxID + 'f'" [disabled]="isDisabled">

    <!-- use  to disble select dropdown -->
    <span class="custom--select__span">
        <ng-select
            #rxNgSelect
            [id]="rxID"
            [items]="dropdownList"
            [bindLabel]="bindLabel"
            [bindValue]="bindValue"
            [ngModel]="inputValue"
            [ngClass]="isDisabled? 'rx--select light_gray rx-select-custom': 'rx--select rx-select-custom'"
            (change)="triggerChange($event)"
            (blur)="triggerOnBlur($event)"
            (keydown.enter)="onEnter($event)"
            [attr.tabindex]="tabIndex"
            [required]="isRequired"
            [title]="titleText || ''"
            [appAutofocus]="autoFocus"
            [autofocusDelay]="100"
            (blur)="validateAllFormFields(inputFormGroup, custContrlName)"
            (keydown.shift.tab)="onShiftTabbingEvent($event)"
            (focus)="focusOnInput()"
            (open)="getWidth()"
            [appendTo]="IsAppendTo ? 'body' : '' "
            [class.appended-dropdown]="IsAppendTo"
            [clearable]="false"
            [searchable]="true"
            [selectOnTab]="true"
            [closeOnSelect]="true"
            [typeToSearchText]="''"
            [readonly]="isDisabled"
            [disabled]="isDisabled"
            [virtualScroll]="false"
        >
            <ng-template ng-label-tmp let-item="item">
                {{ item[bindLabel] }}
                <span *ngIf="item[bindLabel2]">- {{ item[bindLabel2] }}</span>
            </ng-template>
            <!-- <ng-option 
                *ngFor="let list of dropdownList" 
                [value]="list[bindValue]"
                [id]="list[labelForId]"
            >
                {{ list[bindLabel] }}
                <span *ngIf="list[bindLabel2]">- {{ list[bindLabel2] }}</span>
            </ng-option> -->
        </ng-select>
        </span>
    </fieldset>
    <span class="help-block" *ngIf="errorMessage"> {{ errorMessage }} </span>
</div>
